import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";

export default function Product() {
    const { t } = useTranslation();

    // State for modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // Sample image URLs (replace with actual product/machinery images)
    const images = [
        require("../../assets/product/DSC00015.JPG"),
        require("../../assets/product/DSC00024.JPG"),
        require("../../assets/product/DSC00028.JPG"),
        require("../../assets/product/DSC00058.JPG"),
        require("../../assets/product/DSC00063.JPG"),
        require("../../assets/product/DSC00064.JPG"),
        require("../../assets/product/DSC00068.JPG"),
        require("../../assets/product/DSC00071.JPG"),
        require("../../assets/product/DSC00073.JPG"),
    ];

    // Open modal with selected image
    const openModal = (index) => {
        setCurrentImageIndex(index);
        setIsModalOpen(true);
    };

    // Close modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Navigate to previous image
    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    // Navigate to next image
    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <>
            <section className="landingPages bg-gradient-to-b from-gray-100 to-white">
                <div className="container h-full flex items-center justify-between">
                    <div className="w-full md:w-[48%] flex flex-col">
                        <div className="text-[50px] font-bold capitalize text-white">{t("Product")}</div>
                        <div className="font-bold text-white text-[20px] capitalize flex items-center gap-[7px]">
                            <Link to={"/"} className="text-white">{t("Home")}</Link>
                            -
                            <div className="text-white">{t("Product")}</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Products Section */}
            <section className="relative py-[40px] animate-fadeIn">
                <div className="container">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                        <div className="w-100 md:w-1/2">
                            <h2 className="text-[40px] font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6">
                                {t("Our Products")}
                            </h2>
                            <div className="bg-white shadow-lg rounded-lg p-6 text-[18px] leading-relaxed">
                                <p>{t("products_text")}</p>
                            </div>
                        </div>
                        <div className="w-100 md:w-1/2">
                            <img
                                src={images[0]}
                                alt={t("product_image")}
                                className="w-full h-64 object-cover rounded-lg shadow-md"
                            />
                        </div>
                    </div>
                </div>
            </section>

        

            {/* Environmental Importance Section */}
            <section className="relative py-[40px] animate-fadeIn">
                <div className="container">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                        <div className="w-100 md:w-1/2">
                            <h2 className="text-[40px] font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6">
                                {t("Environmental Importance")}
                            </h2>
                            <div className="bg-white shadow-lg rounded-lg p-6 text-[18px] leading-relaxed">
                                <p>{t("environmental_importance")}</p>
                            </div>
                        </div>
                        <div className="w-100 md:w-1/2">
                            <img
                                src={images[2]}
                                alt={t("environmental_image")}
                                className="w-full h-64 object-cover rounded-lg shadow-md"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Product Gallery Section */}
            <section className="relative py-[40px] animate-fadeIn">
                <div className="container">
                    <h2 className="text-[40px] font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6 mx-auto">
                        {t("Product Gallery")}
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="bg-white shadow-lg rounded-lg overflow-hidden cursor-pointer transform transition-transform duration-300 hover:scale-105"
                                onClick={() => openModal(index)}
                            >
                                <img
                                    src={image}
                                    alt={`${t("product_image")} ${index + 1}`}
                                    className="w-full h-48 object-cover"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modal for Image Popup */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 animate-slideIn">
                    <div className="relative max-w-4xl w-full mx-4">
                        <img
                            src={images[currentImageIndex]}
                            alt={`${t("product_image")} ${currentImageIndex + 1}`}
                            className="w-full h-auto max-h-[80vh] object-contain rounded-lg shadow-2xl"
                        />
                        {/* Close Button */}
                        <button
                            onClick={closeModal}
                            className="absolute top-2 right-2 bg-[#E56820] text-white rounded-full w-8 h-8 flex items-center justify-center text-xl font-bold hover:bg-[#c55a1b] transition-colors"
                        >
                            ×
                        </button>
                        {/* Previous Arrow */}
                        <button
                            onClick={prevImage}
                            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-[#E56820] text-white rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-[#c55a1b] transition-colors"
                        >
                            ←
                        </button>
                        {/* Next Arrow */}
                        <button
                            onClick={nextImage}
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#E56820] text-white rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-[#c55a1b] transition-colors"
                        >
                            →
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}